const validationPatterns = {
  email: {
    pattern: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
  },
  postalCode: {
    pattern: /^[0-9]{5}$/,
  },

  msisdn: {
    pattern: /^(\+358|358|0)(\d|\s){6,15}$/,
  },

  notEmpty: {
    pattern: /.*\S.*/,
  },

  ssn: {
    pattern: /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])([5-9]\d\+|\d\d-|[01]\dA)\d{3}[\dABCDEFHJKLMNPRSTUVWXY]$/,
  },
};

export const validate = (value, validationConstant) => {
  let isValid = null;
  if (!validationPatterns[validationConstant]) {
    isValid = validationPatterns.notEmpty.pattern.test(value);
  } else {
    isValid = validationPatterns[validationConstant].pattern.test(value);
  }
  return isValid;
};
